export default __webpack_public_path__ + "static/media/Seal of the Black Wind.d203b01d.jpg";